import { useEffect, useState } from "react";
import { getMe, type Me, openPortal, type Subscription, syncBilling } from "../api";
import { useAuth } from "../AuthContext";
import { Sheet } from "../ui";
import { btnInk } from "./Cram";
import { SubscribeOffer } from "./Paywall";

const formatDate = (ms: number | null) => (ms === null ? "—" : new Date(ms).toLocaleDateString("ja-JP"));

/** Replaces the old settings page: plan, billing portal, and sign-out. */
export function AccountSheet({
  open,
  fromCheckout,
  onClose,
}: {
  open: boolean;
  fromCheckout: boolean;
  onClose: () => void;
}) {
  const { session, signOut } = useAuth();
  const [me, setMe] = useState<Me | null>(null);
  const [subscription, setSubscription] = useState<Subscription | null>(null);
  const [syncing, setSyncing] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!open) return;
    setSyncing(true);
    getMe()
      .then(async (m) => {
        setMe(m);
        setSubscription(m.subscription);
        if (fromCheckout || m.subscription) setSubscription(await syncBilling());
      })
      .catch((e) => setError(e instanceof Error ? e.message : String(e)))
      .finally(() => setSyncing(false));
  }, [open]);

  const manage = () =>
    openPortal()
      .then(({ url }) => {
        window.location.href = url;
      })
      .catch((e) => setError(e instanceof Error ? e.message : String(e)));

  return (
    <Sheet open={open} title="アカウント" onClose={onClose}>
      {syncing && !me && <p className="font-mono text-[12px] font-bold text-ink-3">契約状況を確認しています…</p>}
      {me?.isAdmin && (
        <p className="mb-3 border-l-4 border-marker pl-2 text-[12px] font-bold">管理者: 契約なしで全コレクションを再生できます。</p>
      )}
      {me &&
        (subscription?.active ? (
          <div className="text-[13px] font-bold">
            {fromCheckout && <p className="mb-2 text-shu">お申し込みありがとうございます。すべてのコレクションを再生できます。</p>}
            <p>使い放題 月額 980 円(税込)・{subscription.status === "past_due" ? "お支払い確認中(利用可)" : "契約中"}</p>
            <p className="mt-1 text-ink-2">
              {subscription.cancelAtPeriodEnd ? "解約予定(この日まで利用可)" : "次回更新日"}: {formatDate(subscription.currentPeriodEnd)}
            </p>
          </div>
        ) : (
          <>
            <p className="mb-3 text-[13px] font-bold">未契約です。無料コレクションだけを再生できます。</p>
            <SubscribeOffer />
          </>
        ))}
      {subscription && (
        <button type="button" onClick={manage} className={`${btnInk} mt-4`}>
          お支払い・解約の管理
        </button>
      )}
      {error && <p className="mt-2 text-[12px] font-bold text-shu">{error}</p>}
      <div className="mt-6 flex items-center justify-between gap-3 border-t border-rule pt-3 text-[12px]">
        <span className="truncate text-ink-2">{session?.email}</span>
        <button type="button" onClick={signOut} className="shrink-0 font-bold text-ink-2 underline underline-offset-4 hover:text-shu">
          サインアウト
        </button>
      </div>
    </Sheet>
  );
}
